import React from 'react';
import { pluralizeReviews } from 'src/utils/pluralizeUtils';
import type { ReviewsProps } from '@lt/api/dist/methods/hotelReviews/types';
import { ReviewSwiper } from './ReviewsSwiper';

import styles from '../../reviews.module.css';

export interface ReviewsSwiperContainerProps {
  hasReviewsSection: boolean;
  className?: string;
  totalReviews: number;
  items: ReviewsProps[];
  isShowMoreVisible: boolean;
  isWhitelabel: boolean;
  hotelReviewsLink: string;
}

const ReviewsSwiperContainer = ({
  hasReviewsSection,
  totalReviews,
  className,
  items,
  isShowMoreVisible,
  isWhitelabel,
  hotelReviewsLink,
}: ReviewsSwiperContainerProps): JSX.Element | null => {
  if (!hasReviewsSection) return null;

  return (
    <div className={className}>
      <h2
        className={styles.linkTitleMobile}
      >{`${totalReviews} ${pluralizeReviews(totalReviews)}`}</h2>
      <ReviewSwiper
        items={items.slice(0, 3)}
        isShowMoreVisible={isShowMoreVisible}
        isWhitelabel={isWhitelabel}
        hotelReviewsLink={hotelReviewsLink}
      />
    </div>
  );
};

export default ReviewsSwiperContainer;
